import axiosInstance from "./axios";

export const fetchDayWiseStats = async (from, to, lang = "en") => {
  const response = await axiosInstance.post("/question-stats/day-wise", {
    from,
    to,
    lang,
  });

  const json = response.data;

  if (json.status !== 1) {
    throw new Error(json.message || "Failed to fetch stats");
  }

  return json.data;
};